import { useState } from "react";
import { HomeTitle } from ".";
import { FaQuoteLeft } from "react-icons/fa";
import TrackVisibility from "react-on-screen";

const HomeTestimonials = ({ langWords }) => {
	const [current, setCurrent] = useState(0);
	const [animation, setAnimation] = useState("animate-zoomIn");
	const testimonials = [
		{
			userImage: "https://unsplash.it/200/200",
			userName: "john doe 1",
			usertesitmonial:
				"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quibusdam, autem! Deserunt sint dolorem incidunt. Nostrumveniam velit minus animi quos!",
		},
		{
			userImage: "https://unsplash.it/250/250",
			userName: "john doe 2",
			usertesitmonial:
				"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quibusdam, autem! Deserunt sint dolorem incidunt. Nostrumveniam velit minus animi quos!",
		},
		{
			userImage: "https://unsplash.it/300/300",
			userName: "john doe 3",
			usertesitmonial:
				"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Quibusdam, autem! Deserunt sint dolorem incidunt. Nostrumveniam velit minus animi quos!",
		},
	];
	return (
		<section className="mt-28  bg-primary text-secondary px-4 py-8">
			<HomeTitle title={langWords.testimonials} center color="text-secondary" />
			<div className="container">
				<div>
					<TrackVisibility once>
						{({ isVisible }) => (
							<article
								className={`animate-animated ${
									isVisible ? "animate-backInLeft opacity-100" : "opacity-0"
								} ${
									current === 0 ? "" : animation
								} flex flex-col space-y-3 justify-center items-center`}
							>
								<div>
									<img
										src={testimonials[current].userImage}
										className="rounded-full w-40 h-40 border-b-4 border-third p-1"
										alt="user's profile"
									/>
								</div>
								<blockquote className="space-y-2">
									<cite className="capitalize font-bold text-third block text-center">
										{testimonials[current].userName}
									</cite>
									<div className="text-2xl">
										<FaQuoteLeft />
									</div>
									<p className="max-w-lg text-center opacity-80 border-b-2 border-secondary pb-8 italic">
										<q className="px-2" style={{ quotes: "none" }}>
											{testimonials[current].usertesitmonial}
										</q>
									</p>
								</blockquote>
							</article>
						)}
					</TrackVisibility>
				</div>
				<div className="flex justify-center items-center space-x-2 mt-6">
					{testimonials.map((val, id) => (
						<button
							key={id}
							className={`rounded-full h-8 w-8 ${
								id === current ? "bg-third" : "bg-primary"
							} hover:bg-third hover:border-secondary transition border-2 border-gray-900`}
							onClick={(_) => {
								setCurrent(id);
								setAnimation("");
								setTimeout(() => {
									setAnimation("animate-zoomIn");
								}, 0);
							}}
						>
							{id + 1}
						</button>
					))}
				</div>
			</div>
		</section>
	);
};

export default HomeTestimonials;
